// frontend/src/components/common/MobileBanner.js
//
// Mobile status/insight banner for the Manager Portal (design language from EOD v2).
// Surfaces the key actionable state of a page (flagged tills, low stock, overdue pay)
// in a calm tinted card. Use ONLY on mobile (gate with useIsMobile).
import React from 'react';

const FONT = "'Plus Jakarta Sans', sans-serif";

const TONES = {
    bad:  { bg: '#fef2f2', border: '#fecaca', icBg: '#fee2e2', icColor: '#dc2626', t1: '#991b1b', t2: '#b91c1c' },
    good: { bg: '#f4fbf6', border: '#cdeed8', icBg: '#d1f0db', icColor: '#2563eb', t1: '#1d4ed8', t2: '#2563eb' },
    warn: { bg: '#fffbeb', border: '#fde68a', icBg: '#fef3c7', icColor: '#b45309', t1: '#92400e', t2: '#b45309' },
};

/**
 * @param {object} props
 * @param {'bad'|'good'|'warn'} [props.tone='bad']
 * @param {React.node} props.icon      svg icon node
 * @param {string} props.title         bold headline
 * @param {string} [props.subtitle]    supporting line
 * @param {() => void} [props.onClick] makes the banner tappable (shows a chevron)
 */
export default function MobileBanner({ tone = 'bad', icon, title, subtitle, onClick }) {
    const c = TONES[tone] || TONES.bad;
    return (
        <div
            onClick={onClick}
            role={onClick ? 'button' : undefined}
            style={{
                display: 'flex', alignItems: 'center', gap: 12, borderRadius: 16,
                padding: '14px 16px', marginBottom: 22, background: c.bg, border: `1px solid ${c.border}`,
                cursor: onClick ? 'pointer' : 'default', fontFamily: FONT,
            }}
        >
            {icon && (
                <div style={{ width: 38, height: 38, borderRadius: '50%', background: c.icBg, color: c.icColor, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>{icon}</div>
            )}
            <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 14, fontWeight: 800, color: c.t1 }}>{title}</div>
                {subtitle && <div style={{ fontSize: 12, color: c.t2, marginTop: 1, fontWeight: 500 }}>{subtitle}</div>}
            </div>
            {onClick && (
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={c.t2} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}><polyline points="9 18 15 12 9 6" /></svg>
            )}
        </div>
    );
}
